var defaultDropDownOptions = {
    maxHeight: "120px",
};

export { defaultDropDownOptions };
